import styled from "styled-components";

interface StyleProps {
  $isPhone?: boolean;
  $hasError?: boolean; // 👈 add this line
}

export const SectionWrapper = styled.section<StyleProps>`
  padding-inline: ${({ $isPhone }) => ($isPhone ? "16px" : "57px")}; // 📱
  background: #fbfbfc;
  display: flex;
  justify-content: ${({ $isPhone }) => ($isPhone ? "center" : "end")}; // 📱
  align-items: center;
  margin-left: ${({ $isPhone }) => ($isPhone ? "0" : "57px")}; // 📱
  height: 100%;
`;

export const OtpBox = styled.div<StyleProps>`
  display: flex;
  flex-direction: column;
  width: ${({ $isPhone }) => ($isPhone ? "100%" : "567px")}; // 📱
  height: fit-content;
  border-radius: 24px;
  padding: ${({ $isPhone }) => ($isPhone ? "24px" : "44px")}; // 📱
  background: #ffffff;
  box-shadow:
    0px 2px 3px 0px #0000000a,
    0px 24px 68px 0px #2f30370d,
    0px 4px 6px 0px #222a350a,
    0px 1px 1px 0px #0000000d;
`;

export const Title = styled.span<StyleProps>`
  font-weight: 700;
  font-size: ${({ $isPhone }) => ($isPhone ? "24px" : "32px")}; // 📱
  color: #261b6a;
  margin-top: 26px;
`;

export const EmailInfo = styled.div<StyleProps>`
  display: ${({ $isPhone }) => ($isPhone ? "flex" : "block")}; // 📱
  flex-direction: ${({ $isPhone }) => ($isPhone ? "column" : "row")}; // 📱
  gap: ${({ $isPhone }) => ($isPhone ? "4px" : "8px")}; // 📱
  margin-top: ${({ $isPhone }) => ($isPhone ? "12px" : "0")}; // 📱

  span:first-child {
    font-weight: 400;
    font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")}; // 📱
    color: #261b6a;
  }

  span:last-child {
    font-weight: 400;
    font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")}; // 📱
    color: #5b3fff;
    cursor: pointer;
    margin-inline: ${({ $isPhone }) => ($isPhone ? "" : "16px")}; // 📱
  }
`;

export const OtpInputs = styled.div<StyleProps>`
  direction: ltr;
  unicode-bidi: isolate;
  display: flex;
  gap: ${({ $isPhone }) => ($isPhone ? "4px" : "8px")}; // 📱
  margin-block: 26px;
  justify-content: ${({ $isPhone }) =>
    $isPhone ? "space-between" : "flex-start"}; // 📱
  flex-wrap: ${({ $isPhone }) => ($isPhone ? "wrap" : "nowrap")}; // 📱
`;

export const OtpInput = styled.input<StyleProps>`
  text-align: center; // ✅ This line centers placeholder and input text
  font-weight: 500;
  font-size: 30px;
  color: #261b6a;
  width: ${({ $isPhone }) => ($isPhone ? "calc(50% - 6px)" : "113.75px")}; // 📱
  height: ${({ $isPhone }) => ($isPhone ? "56px" : "72px")}; // 📱
  border-radius: 8px;
  padding: ${({ $isPhone }) => ($isPhone ? "16px" : "24px 16px")}; // 📱
  border: 1px solid ${({ $hasError }) => ($hasError ? "#ff4d4f" : "#efeff1")}; // 🔴 Red on error
  outline: none;

  &:focus {
    border: 1px solid #261b6a; // or your brand primary color
  }
`;

export const ResendWrapper = styled.div<StyleProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ $isPhone }) => ($isPhone ? "4px" : "8px")}; // 📱
  flex-direction: ${({ $isPhone }) => ($isPhone ? "column" : "row")}; // 📱
  margin-top: ${({ $isPhone }) => ($isPhone ? "12px" : "0")}; // 📱

  span:first-child {
    font-weight: 700;
    font-size: 14px;
    color: #0000004d;
  }

  span:last-child {
    font-weight: 500;
    font-size: 14px;
    color: #5b3fff;
    cursor: pointer;
  }
`;

export const ConfirmWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 26px;
`;

export const ConfirmButton = styled.button<StyleProps>`
  font-weight: 700;
  font-size: 14px;
  background: #5b3fff;
  border-radius: 69px;
  width: ${({ $isPhone }) => ($isPhone ? "100%" : "479px")};
  height: 49px;
  color: #ffffff;
  border: none;
  cursor: pointer;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  transition: 0.2s;
`;
